import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyByu0RFjFyaNsJL37M5vr8A-Xg7UBfxb0o",
  authDomain: "daftar-hadir-online-bensco.firebaseapp.com",
  projectId: "daftar-hadir-online-bensco",
  storageBucket: "daftar-hadir-online-bensco.firebasestorage.app",
  messagingSenderId: "893413846274",
  appId: "1:893413846274:web:c6f09aa8c365e6af92261b",
  measurementId: "G-0XK3Y6HLSY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Improved anonymous sign-in with error handling
let authInitialized = false;

const initAuth = async () => {
  try {
    await signInAnonymously(auth);
    authInitialized = true;
    console.log("Anonymous authentication successful");
  } catch (error) {
    console.error("Anonymous authentication error:", error);
    // You can implement fallback logic here if needed
  }
};

// Initialize auth when the app starts
initAuth();

export { db, auth, authInitialized };
